const maxLengthValidator = (len = 12, string = ''): boolean => string.trim().length <= len;

export default maxLengthValidator;
